<template>
  <div class="row" v-on:mousemove="checkInactivityMoveMouse">
    <header-servico
      tipo="Acompanhamento"
      :loading="loading"
      page="paf"
      :familia="familia.id"
    />
    <load v-if="loading" message="Carregando acompanhamentos da Família" />
    <div v-else class="col-md-12">
      <div class="row">
        <div
          class="col-md-12"
          v-if="acompanhamento.status != status_final_id"
          v-html="acompanhamento ? getPrazo(acompanhamento.data_avaliacao) : ''"
        ></div>
      </div>
      <!--Tabela-->
      <div class="row">
        <SidebarServico @page="showPage" />

        <ModalVerificarPrivado
          :familia-id="familia.id"
          v-if="acompanhamento.privado == 1 && status_privado == false"
          @liberar="status_privado = true"
        />
        <div
          v-else
          class="col-md-9"
          v-on:mousemove="status_privado = !checkInactivity"
        >
          <header-familia :item="acompanhamento.familia" />

          <div v-if="page == 'acompanhamento'">
            <div class="card mb-0 shadow" v-if="historicoStatus == false">
              <div class="card-body">
                <div class="tab-content">
                  <div class="animate__animated animate__fadeIn">
                    <div class="row">
                      <div class="col-12">
                        <h4 class="font-weight-bold">
                          Gestão do Acompanhamento
                        </h4>
                      </div>
                      <HeaderAcompanhamento :acompanhamento="acompanhamento" />
                      <form-select
                        v-model="acompanhamento.servico_id"
                        label="Serviço"
                        grid="6"
                        :itens="servicos"
                        :required="true"
                        :disabled="
                          acompanhamento.editado == 1 || loadingServicos == true
                            ? true
                            : false
                        "
                        :loading="loadingServicos"
                      />
                      <form-select
                        v-model="acompanhamento.tecnico_id"
                        label="Técnico de referência"
                        :required="true"
                        grid="6"
                        :itens="listtecnicos"
                        :loading="loadingTecnicos"
                        :disabled="loadingTecnicos"
                      />
                      <form-calendar
                        v-model="acompanhamento.data_ingresso"
                        grid="3"
                        label="Data de início"
                        :required="true"
                      />
                      <form-calendar
                        v-model="acompanhamento.data_final"
                        grid="3"
                        label="Data Final"
                      />
                      <form-calendar
                        v-model="acompanhamento.data_avaliacao"
                        grid="3"
                        label="Data Avaliação"
                        :required="true"
                      />
                      <form-select
                        v-model="acompanhamento.periodicidade"
                        label="Periodicidade"
                        grid="3"
                        :itens="$root.arrays.acompanhamento_periodicidade"
                        :required="true"
                      />

                      <form-select
                        v-model="acompanhamento.vulnerabilidades"
                        label="Vulnerabilidades"
                        :multiple="true"
                        :itens="vulnerabilidades"
                        :disabled="
                          loadingVulnerabilidades == true
                            ? true
                            : false
                        "
                        :loading="loadingVulnerabilidades"
                      />
                      <form-select
                        v-model="acompanhamento.violencias"
                        label="Violência/Violações de direito"
                        :multiple="true"
                        :itens="violencias"
                        :disabled="
                          loadingViolencias == true
                            ? true
                            : false
                        "
                        :loading="loadingViolencias"
                      />
                      <form-textarea-editor
                        v-model="acompanhamento.potencialidades"
                        label="Potencialidades"
                      />
                      <form-textarea-editor
                        v-model="acompanhamento.fragilidades"
                        label="Fragilidades"
                      />
                      <form-textarea-editor
                        v-model="acompanhamento.diagnostico"
                        label="Avaliação Técnica"
                        @onfocus="changeIsEditNow"
                        @onblur="changeIsEditNow"
                      />
                      <Meta
                        :acompanhamento="acompanhamento"
                        class="mb-3"
                      />

                      <form-textarea-editor
                        v-model="acompanhamento.estrategia"
                        label="Intervenção"
                        @onfocus="changeIsEditNow"
                        @onblur="changeIsEditNow"
                      />
                      <form-textarea-editor
                        v-model="acompanhamento.recursos_mobilizados"
                        label="Objetivos a serem atingidos"
                      />

                      <form-select
                        v-if="tecnicos"
                        v-model="acompanhamento.tecnicos"
                        label="Outros técnicos"
                        :multiple="true"
                        :itens="listtecnicos"
                      />
                    </div>

                    <div
                      class="row pt-4 px-0 d-flex justify-content-between align-items-center"
                    >
                      <div class="row pl-3">
                        <form-select
                          v-model="acompanhamento.status"
                          label="Status"
                          :itens="status"
                          @change="verificarStatus"
                          :loading="loadingStatus"
                          grid="7"
                          :ajuda="ajuda_status"
                        />
                        <form-toggle
                          grid="5"
                          class="mt-4"
                          v-model="acompanhamento.privado"
                          label="Sigilo?"
                        />
                      </div>
                      <div class="col-auto px-2 mt-2 text-right">
                        <a
                          class="router-link-exact-active active px-3"
                          @click="historicoStatus = true"
                        >
                          <i class="fas fa-history"></i>
                          Histórico de Status
                        </a>
                        <b-button
                          :title="$t('Visualizar e Imprimir')"
                          :to="
                            '/dashboard/acompanhamento/show/' +
                            acompanhamento.id
                          "
                          class="py-1"
                          size="sm"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                        >
                          <i class="mdi mdi-printer mdi-18px" />
                        </b-button>
                        <a
                          class="btn btn-primary"
                          @click="$bvModal.show('modal-auditoria')"
                          :title="$t('Auditoria')"
                          v-b-tooltip.hover
                        >
                          <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                        </a>
                        <a
                          v-if="
                            $store.state.user.role_details.name == 'Admin' ||
                            $store.state.user.role_details.name ==
                              'Gestor(a)' ||
                            $store.state.user.id == acompanhamento.user_id
                          "
                          title="Remanejar"
                          class="btn btn-warning py-2"
                          @click="
                            $bvModal.show('modal-remanejar-acompanhamento')
                          "
                        >
                          <i class="fas fa-exchange-alt mdi-18px" />
                          {{ $t("Remanejar") }}
                        </a>
                        <button
                          class="btn btn-success btn-submit"
                          data-style="zoom-in"
                          type="submit"
                          @click="submit"
                          :disabled="
                            acompanhamento.status == status_final_id
                              ? true
                              : false
                          "
                        >
                          <i class="mdi mdi-content-save" />
                          {{ $t("Salvar") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 shadow card-body" v-else>
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Gestão do Acompanhamento</h4>
                    </div>
                    <HeaderAcompanhamento :acompanhamento="acompanhamento" />
                    <HistoricoStatus
                      @voltar="historicoStatus = false"
                      :id="acompanhamento.id"
                      :familia="acompanhamento.familia_id"
                      :status="status_acompanhamento"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Anexo :acompanhamento="acompanhamento" v-if="page == 'anexo'" />
          <Atendimento
            :acompanhamento="acompanhamento"
            v-if="page == 'atendimento'"
          />
          <Atividade
            :acompanhamento="acompanhamento"
            v-if="page == 'atividade'"
          />
          <Avaliacao
            :status="status_acompanhamento"
            @save="verificarStatus"
            :acompanhamento="acompanhamento"
            @atualizarPagina="page = $event"
            v-if="page == 'avaliacao'"
          />
          <Comentario
            :acompanhamento="acompanhamento"
            v-if="page == 'comentario'"
          />
          <Desligamento
            :status="status"
            :acompanhamento="acompanhamento"
            v-if="page == 'desligamento'"
          />
          <Encaminhamento
            :acompanhamento="acompanhamento"
            v-if="page == 'encaminhamento'"
          />
          <HistoricoEstrategia
            :acompanhamento="acompanhamento"
            v-if="page == 'estrategia'"
          />
          <HistoricoDiagnostico
            :acompanhamento="acompanhamento"
            v-if="page == 'diagnostico'"
          />
          <HistoricoAvaliacao
            :acompanhamento="acompanhamento"
            v-if="page == 'historico_avaliacao'"
          />
          <Oficio :acompanhamento="acompanhamento" v-if="page == 'oficio'" />
        </div>
      </div>
    </div>
    <status-historico
      model="Paf"
      modulo="PAF"
      titulo_modulo="ACOMPANHAMENTO"
      :id="acompanhamento.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_acompanhamento"
      @submit="submit"
    />
    <remanejar-acompanhamento :acompanhamento="acompanhamento" />
    <ModalAuditoria
      servico="acompanhamento"
      :servico_id="acompanhamento.id"
    />
  </div>
</template>
<script>
import ModalVerificarPrivado from "./includes/ModalVerificarPrivado";
import SidebarServico from "./includes/SidebarServico";
import HeaderAcompanhamento from "./HeaderAcompanhamento";
import HistoricoStatus from "./HistoricoStatus";
import Anexo from "./includes/abas/Anexo";
import Atendimento from "./includes/abas/Atendimento";
import Atividade from "./includes/abas/Atividade";
import Avaliacao from "./includes/abas/Avaliacao";
import Comentario from "./includes/abas/Comentario";
import Desligamento from "./includes/abas/Desligamento";
import Encaminhamento from "./includes/abas/Encaminhamento";
import HistoricoDiagnostico from "./includes/abas/HistoricoDiagnostico";
import HistoricoEstrategia from "./includes/abas/HistoricoEstrategia";
import HistoricoAvaliacao from "./includes/abas/HistoricoAvaliacao";
import Meta from "./includes/abas/Meta";
import Oficio from "./includes/abas/Oficio";
import ModalAuditoria from "../../../../../resources/js/dashboard/components/widgets/ModalAuditoria";
export default {
  components: {
    ModalVerificarPrivado,
    HeaderAcompanhamento,
    SidebarServico,
    Anexo,
    Atendimento,
    Atividade,
    Avaliacao,
    Comentario,
    Desligamento,
    Encaminhamento,
    HistoricoEstrategia,
    HistoricoDiagnostico,
    HistoricoAvaliacao,
    HistoricoStatus,
    Meta,
    Oficio,
    ModalAuditoria,
  },
  name: "Edit",
  data() {
    return {
      page: "acompanhamento",
      statusAtual: "",
      statusAnterior: "",
      acompanhamento: {},
      tecnicos: [],
      unidades: {},
      tipos: {},
      servicos: {},
      familia: {},
      status_acompanhamento: {},
      status_final_id: "",
      status_aberto_id: "",
      files: {},
      loading: true,
      progressCompleted: 0,
      status_privado: false,
      historicoStatus: false,
      status: [],
      inativo: false,
      vulnerabilidades: {},
      violencias: {},
      model: "Paf",
      loadingTecnicos: false,
      loadingServicos: false,
      loadingVulnerabilidades: false,
      loadingViolencias: false,
      loadingStatus: false,
      isEditNow: false,
      ajuda_status: `<b>ABERTO:</b> O status aberto é indicado quando o usuário da plataforma registra o Plano de Acompanhamento Familiar, no caso esse status aponta que foi iniciado um registro, e posterior será possível a continuidade do registro, além do gerenciamento e indicação de outros status ( continuidade do acompanhamento);<br><br>
            <b>EM ANDAMENTO:</b> O status Em Andamento é registrado sempre que o usuário da Plataforma gerencia o acompanhamento de aberto para em andamento, como meio de registrar que o grupo familiar está em acompanhamento ativo;<br><br>
            <b>FINALIZADO:</b> O Status Finalizado é indicado sempre que o usuário da Plataforma,após gerenciar um Plano de Acompanhamento Familiar, atualiza o status para finalizado informando os motivos pelo qual está encerrando a intervenção. Os motivos podem ser: superação da problemática; retorno para cidade de origem (recambio), não adesão ao serviço; mudança de cidade; óbito, encaminhamento para outros serviços, acompanhamento/avaliação finalizado, e outros motivos que culminaram na finalização do acompanhamento.<br><br>
            <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`,
    };
  },
  mounted() {
    this.getAcompanhamento();
    // this.saveAutomatic(); Remover salvamento automático
    this.$bvModal.show("verificar-acompanhamento-privado");
    if (this.acompanhamento.is_owner == false) {
      this.$router.push(
        `/dashboard/acompanhamento/show/${this.acompanhamento.id}`
      );
    }
  },
  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: elem.value,
      }));
      return map;
    },
    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-acompanhamento-privado");
      }
      return this.$root.isIdle;
    },
  },
  methods: {
    changeIsEditNow(status) {
      this.isEditNow = status;
      //console.log("teste " + status);
    },
    verificarStatusEmAndamento() {
      if (this.getStatusNome(this.acompanhamento.status) != "ABERTO") {
        let index = this.status.findIndex((x) => x.value === "ABERTO");
        this.status.splice(index, 1);
      }
    },
    getStatusNome(id) {
      const result = this.status.filter((elem) => elem.id == id);
      return result[0] ? result[0].value : null;
    },
    checkInactivityMoveMouse() {
      if (this.acompanhamento.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-acompanhamento-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },
    saveAutomatic() {
      setTimeout(() => {
        var meta = this.$route.meta.controller;
        if (
          this.page == "acompanhamento" &&
          this.acompanhamento.status != this.status_aberto_id &&
          this.acompanhamento.status != this.status_final_id
        ) {
          if (meta == "PafController") {
            if (this.isEditNow == false) {
              this.submit(true);
            }
            this.saveAutomatic();
          }
        }
      }, 30000);
    },
    showPage(page) {
      this.page = page;
    },
    submitFile(files) {
      this.files = files;
    },
    getVulnerabilidades() {
      this.loadingVulnerabilidades = true;
      axios.get(`api/dashboard/get/vulnerabilidades`).then((response) => {
        this.vulnerabilidades = response.data;
        this.loadingVulnerabilidades = false;
      });
    },
    getViolencias() {
      this.loadingViolencias = true;
      axios.get(`api/dashboard/get/violencias`).then((response) => {
        this.violencias = response.data;
        this.loadingViolencias = false;
      });
    },
    getAcompanhamento() {
      this.loading = true;
      axios
        .get(`api/dashboard/acompanhamentos/${this.$route.params.id}`)
        .then((response) => {
          this.acompanhamento = response.data.data;
          this.statusAnterior = this.acompanhamento.status;
          this.familia = this.acompanhamento.familia_id;
          this.$route.query.familia_id = this.acompanhamento.familia_id.id;

          this.getViolencias();
          this.getVulnerabilidades();
          this.getStatusFinais();
          this.getTecnicos();
          this.getStatus();
          this.getServicos();
          this.getUnidades();
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          //console.log(this.$route.query.familia_id);
          if (this.$route.query.familia_id) {
            this.$router.push(
              `/dashboard/acompanhamentos/${this.$route.query.familia_id}`
            );
          } else {
            this.$router.push(`/dashboard/familias`);
          }
        });
    },
    verificarStatus(status) {
      this.statusAtual = status;
      this.acompanhamento.status = this.statusAtual;
      const result = this.status_acompanhamento.filter(
        (item) => item.id == status
      );

      if (result[0].final == 1) {
        //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
        this.$bvModal.show(`status-historico-${this.model}`);
      }
    },
    getUnidades() {
      axios
        .get(`api/dashboard/unidades/get/externas/PLANTAO`)
        .then((response) => {
          this.unidades = response.data;
        });
    },
    getStatusFinalizado() {
      const result = this.status_acompanhamento.filter(
        (status) => status.descricao == "FINALIZADO"
      );
      return result[0].id;
    },
    getStatusFinais() {
      axios
        .post(`api/dashboard/get/status/finais`, {
          model: "Paf",
          module: "PAF",
        })
        .then((response) => {
          this.status_acompanhamento = response.data;

          this.status_final_id = this.getStatusFinalizado();
        });
    },
    getTecnicos() {
      this.loadingTecnicos = true;
      axios.get(`api/dashboard/tecnicos/get`).then((response) => {
        this.tecnicos = response.data;
        this.loadingTecnicos = false;
      });
    },
    getTipos() {
      axios.get(`api/dashboard/acompanhamento/tipos`).then((response) => {
        this.tipos = response.data;
      });
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/status/acompanhamento`)
        .then((response) => {
          this.status = response.data;

          this.status.filter((elem) => {
            if (elem.value == "ABERTO") {
              this.status_aberto_id = elem.id;
            }
          });
        })
        .finally(() => {
          this.verificarStatusEmAndamento();
          this.loadingStatus = false;
        });
    },
    getServicos() {
      this.loadingServicos = true;
      axios.get(`api/dashboard/acompanhamento/servicos`).then((response) => {
        this.servicos = response.data;
        this.loadingServicos = false;
      });
    },
    setTipos(tipos) {
      this.tipos = tipos;
    },
    submit(automatico = false) {
      var historico_save = automatico != "historico" ? false : automatico;
      this.acompanhamento.familia_id = this.familia.id;
      this.acompanhamento.automatico = automatico != true ? false : true;

      // if (this.acompanhamento.data_ingresso) {
      //   this.acompanhamento.data_ingresso = moment(
      //     this.acompanhamento.data_ingresso,
      //     "YYYY-MM-DD"
      //   ).format("DD/MM/YYYY");
      // }
      // if (this.acompanhamento.data_final) {
      //   this.acompanhamento.data_final = moment(
      //     this.acompanhamento.data_final,
      //     "YYYY-MM-DD"
      //   ).format("DD/MM/YYYY");
      // }
      // if (this.acompanhamento.data_avaliacao) {
      //   this.acompanhamento.data_avaliacao = moment(
      //     this.acompanhamento.data_avaliacao,
      //     "YYYY-MM-DD"
      //   ).format("DD/MM/YYYY");
      // }

      // corrige auditoria de data_ingresso
      if (this.acompanhamento.data_ingresso) {
        this.acompanhamento.data_ingresso = moment(this.acompanhamento.data_ingresso).format('YYYY-MM-DD');
      }

      let formData = new FormData();

      for (var key in this.acompanhamento) {
        formData.append(key, this.acompanhamento[key]);
      }
      let ladda = "";
      if (historico_save != "historico") {
        let btnClass = document.querySelector(".btn-submit");
        if (btnClass) {
          ladda = Ladda.create(btnClass);
          ladda.start();
        }
      }

      axios
        .post(`api/dashboard/update/acompanhamento`, formData)
        .then((response) => {
          this.acompanhamento = response.data.data;
          historico_save != "historico" ? ladda.stop() : "";
          this.$snack.success({
            button: false,
            text: "Acompanhamento atualizado com sucesso.",
          });
          // this.$router.push(`/dashboard/Acompanhamentos/edit/${response.data.id}`);
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
    renderAlert(mensagem, tipo) {
      return `<div class="alert alert-${tipo} alert-dismissible fade show" role="alert">${mensagem}<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>`;
    },
    getPrazo(data) {
      if (data) {
        var data_final = moment(data);
        var data_atual = moment();
        var prazo = data_final.diff(data_atual, "days");

        if (prazo > 3) {
          return this.renderAlert(
            `O prazo para avaliação é de <strong>${prazo} dia(s) </strong>`,
            "info"
          );
        } else if (prazo > 1 && prazo < 3) {
          return this.renderAlert(
            `O prazo para avaliação é de <strong>${prazo} dia(s) </strong>`,
            "warning"
          );
        } else if (prazo == 0) {
          return this.renderAlert(
            `<strong>Último dia para avaliar! </strong>`,
            "danger"
          );
        } else if (prazo < 0) {
          return this.renderAlert(
            `Sua avaliação está <strong>${
              prazo * -1
            }</strong> dia(s) em atraso!`,
            "danger"
          );
        }
      }
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
